import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { FireHubPage } from '../pages/FireHubPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/fire' as any)({
  component: Fire,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function Fire() {
  return (
    <MainLayout>
      <FireHubPage />
    </MainLayout>
  )
}
